module.exports = {
  APP_BAR_HEIGHT: 50,
  APP_SIDEBAR_WIDTH: 280,
  APP_MINI_SIDEBAR_WIDTH: 48,
}
